// The Queue's To Address filter option for an email contact with no To
// address (2026-10-30, prod contacts 5047459 and 9535116). Ingest now always
// stores one (the ingesting mailbox when no recipient is ours), but a
// contact stored before that, or any future gap, must never be hidden by a
// narrowed filter: this option is ticked by default. It travels in the same
// includeToAddress list as the addresses, so it is lowercase, has no comma
// and can never be an email address.
export const NO_TO_ADDRESS = '__none__'
